 
import { createSlice } from '@reduxjs/toolkit';
import {
  ClinicalTrialAffiliatesState,
  ClinicalTrialAffiliatesFetchSuccessAction,
} from './clinicalTrialAffiliates.types';
import { createSliceHook, makeActionCreator, createSelector } from '../helpers';

const initialState: ClinicalTrialAffiliatesState = {
  loading: false,
  error: undefined,
  data: [],
};

const { actResolve, actReject, actReq } = makeActionCreator<ClinicalTrialAffiliatesState>();

export const clinicalTrialAffiliatesSlice = createSlice({
  name: 'clinicalTrialAffiliates',
  initialState,
  reducers: {
    fetchClinicalTrialAffiliates: actReq(),
    fetchClinicalTrialAffiliatesSuccess: actResolve<ClinicalTrialAffiliatesFetchSuccessAction['payload']>(),
    fetchClinicalTrialAffiliatesFailure: actReject(),
  },
});

export const {
  fetchClinicalTrialAffiliates,
  fetchClinicalTrialAffiliatesSuccess,
  fetchClinicalTrialAffiliatesFailure,
} = clinicalTrialAffiliatesSlice.actions;

export const actions = {
  ...clinicalTrialAffiliatesSlice.actions,
};

export const useClinicalTrialAffiliatesSlice = createSliceHook(clinicalTrialAffiliatesSlice.name, actions);

export const selectClinicalTrialAffiliatesState = createSelector('clinicalTrialAffiliates');
